export class Favorites {
    id: string;
    scr_name: string;
    scr_code: string;
    favor:any;



}



// WEBPACK FOOTER //
// ./src/app/model/favorites.ts